import { render, staticRenderFns } from "./StageForm.vue?vue&type=template&id=0bf3aca6&scoped=true&lang=pug&"
import script from "./StageForm.vue?vue&type=script&lang=js&"
export * from "./StageForm.vue?vue&type=script&lang=js&"
import style0 from "./StageForm.vue?vue&type=style&index=0&id=0bf3aca6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf3aca6",
  null
  
)

export default component.exports